// extracted by mini-css-extract-plugin
export default {"table":"TemplateTemp_table__xmp1N"};